import { useNavigate } from "react-router-dom";
import Reveal from "./Reveal";
import { useLang } from "../i18n/LanguageContext";

const STORIES = {
  en: {
    eyebrow: "From the atelier",
    entries: [
      {
        line: "Some pieces are made for someone. This one was made with them.",
        link: "Read Heidrun's story",
        to: "/heidrun",
        testid: "story-link-heidrun",
      },
      {
        line: "Some things we keep until the story they belong to is ready to close.",
        link: "Read the wreath's story",
        to: "/wreath",
        testid: "story-link-wreath",
      },
      {
        line: "I wasn't choosing materials because they matched — I was choosing memories.",
        link: "Read the dreamcatcher's story",
        to: "/dreamcatcher",
        testid: "story-link-dreamcatcher",
      },
      {
        line: "There were two girls from Haugesund. But sometimes, they were Caroline and Line.",
        link: "Read Co-Creation No. 001",
        to: "/co-creation-001",
        testid: "story-link-cocreation",
      },
    ],
  },
  no: {
    eyebrow: "Fra atelieret",
    entries: [
      {
        line: "Noen verk lages for noen. Dette ble laget sammen med dem.",
        link: "Les Heidruns historie",
        to: "/heidrun",
        testid: "story-link-heidrun",
      },
      {
        line: "Noen ting tar vi vare på til historien de hører hjemme i, er klar til å lukke seg.",
        link: "Les kransens historie",
        to: "/wreath",
        testid: "story-link-wreath",
      },
      {
        line: "Jeg valgte ikke materialer fordi de passet sammen — jeg valgte minner.",
        link: "Les drømmefangerens historie",
        to: "/dreamcatcher",
        testid: "story-link-dreamcatcher",
      },
    ],
  },
};

export default function StoriesTeaser() {
  const { lang } = useLang();
  const navigate = useNavigate();
  const t = STORIES[lang];

  return (
    <section className="border-t border-clay/60 bg-paper py-20 sm:py-24" data-testid="stories-teaser">
      <div className="mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <p className="ttwk-label">{t.eyebrow}</p>
          <div className="mt-10 flex flex-col gap-12">
            {t.entries.map((e) => (
              <div key={e.to} className="flex flex-col items-center">
                <p className="mx-auto max-w-2xl font-serif text-2xl font-light italic leading-snug sm:text-3xl">{e.line}</p>
                <button
                  onClick={() => navigate(e.to)}
                  className="link-underline mt-6 text-[11px] uppercase tracking-[0.2em] text-terracotta"
                  data-testid={e.testid}
                >
                  {e.link}
                </button>
              </div>
            ))}
            <div className="mt-14 border-t border-clay/60 pt-8">
              <button
                onClick={() => navigate("/letters")}
                className="link-underline text-[11px] uppercase tracking-[0.2em] text-umber transition-colors duration-300 hover:text-terracotta"
                data-testid="letters-archive-link"
              >
                Letters from the atelier — No. 01 &amp; No. 02
              </button>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
